@if (!stockLoading() && stockError()) {
  <ideal-error [error]="stockError()" mode="button"></ideal-error>
} @else {
  <div withLoadingSkeleton [isLoading]="!stockReady()">
    <ideal-item-stock-button-view [itemId]="id()" [stockLocation]="state()!" [stockAmount]="stockTotal()" />
  </div>
}
